export enum GoogleSitesOrderingEnum {
  Name = 'name',
  LastModifiedDate = 'lastModifiedTime',
}
